import { render, staticRenderFns } from "./visitSave.vue?vue&type=template&id=ffa4b078&scoped=true&"
import script from "./visitSave.vue?vue&type=script&lang=js&"
export * from "./visitSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa4b078",
  null
  
)

export default component.exports